import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

export class InstitutionDashboardApi {
  constructor() {
    this.baseApi = ENV.BASE_API;
    // Asumimos que la base es /api/v1
  }

  // 1. Obtener lista para el Select de filtro
  async getTherapistsList(token) {
    const url = `${this.baseApi}/revi/institution-dashboard/therapists-list`;
    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });
    const json = await response.json();
    if (!response.ok)
      throw new Error(json.message || "Error cargando lista de terapeutas");
    return json.therapists || [];
  }

  // 2. Obtener KPIs (Summary)
  async getSummary(token, { timeRange, therapistId }) {
    // Construimos query string
    const params = new URLSearchParams();
    if (timeRange) params.append("timeRange", timeRange);
    if (therapistId) params.append("therapistId", therapistId);

    const url = `${this.baseApi}/revi/institution-dashboard/summary?${params.toString()}`;
    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });
    const json = await response.json();
    if (!response.ok) throw new Error(json.message || "Error cargando summary");
    return json;
  }

  // 3. Obtener Gráficas
  async getCharts(token, { timeRange, therapistId }) {
    const params = new URLSearchParams();
    if (timeRange) params.append("timeRange", timeRange);
    if (therapistId) params.append("therapistId", therapistId);

    const url = `${this.baseApi}/revi/institution-dashboard/charts?${params.toString()}`;
    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });
    const json = await response.json();
    if (!response.ok) throw new Error(json.message || "Error cargando charts");
    return json;
  }

  // 4. Obtener Actividad Reciente
  async getActivity(token, { therapistId }) {
    const params = new URLSearchParams();
    if (therapistId) params.append("therapistId", therapistId);

    const url = `${this.baseApi}/revi/institution-dashboard/activity?${params.toString()}`;
    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });
    const json = await response.json();
    if (!response.ok)
      throw new Error(json.message || "Error cargando actividad");
    return json;
  }
}
